<template>
  <svg
    v-if="type == 'chart_up'"
    class="chart_up"
    width="17"
    height="21"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.646447 12.6464C0.451184 12.8417 0.451184 13.1583 0.646447 13.3536C0.841709 13.5488 1.15829 13.5488 1.35355 13.3536L0.646447 12.6464ZM6 8L6.35355 7.64645C6.15829 7.45118 5.84171 7.45118 5.64645 7.64645L6 8ZM9 11L8.64645 11.3536C8.84171 11.5488 9.15829 11.5488 9.35355 11.3536L9 11ZM17 3L11.4232 4.49429L15.5057 8.57678L17 3ZM1.35355 13.3536L6.35355 8.35355L5.64645 7.64645L0.646447 12.6464L1.35355 13.3536ZM5.64645 8.35355L8.64645 11.3536L9.35355 10.6464L6.35355 7.64645L5.64645 8.35355ZM9.35355 11.3536L14.1716 6.53553L13.4645 5.82843L8.64645 10.6464L9.35355 11.3536Z"
      :fill="color"
    />
  </svg>

  <svg
    v-if="type == 'chart_stagnant'"
    width="17"
    height="21"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.4502 3.83496L13.2002 6.00002L9.4502 8.16509V6.37502H5.10553L1.46536 10.0152C1.31891 10.1616 1.08148 10.1616 0.93503 10.0152C0.788584 9.86874 0.788584 9.63131 0.93503 9.48486L4.68503 5.73486C4.75536 5.66453 4.85074 5.62502 4.9502 5.62502H9.4502V3.83496Z"
      :fill="color"
    />
  </svg>

  <svg
    v-if="type == 'chart_down'"
    class="chart_down"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.146447 3.68705C-0.0488155 3.49179 -0.0488155 3.17521 0.146447 2.97994C0.341709 2.78468 0.658291 2.78468 0.853553 2.97994L0.146447 3.68705ZM5.5 8.3335L5.85355 8.68705C5.65829 8.88231 5.34171 8.88231 5.14645 8.68705L5.5 8.3335ZM8.5 5.3335L8.14645 4.97994C8.34171 4.78468 8.65829 4.78468 8.85355 4.97994L8.5 5.3335ZM16.5 13.3335L10.9232 11.8392L15.0057 7.75672L16.5 13.3335ZM0.853553 2.97994L5.85355 7.97994L5.14645 8.68705L0.146447 3.68705L0.853553 2.97994ZM5.14645 7.97994L8.14645 4.97994L8.85355 5.68705L5.85355 8.68705L5.14645 7.97994ZM8.85355 4.97994L13.6716 9.79796L12.9645 10.5051L8.14645 5.68705L8.85355 4.97994Z"
      :fill="color"
    />
  </svg>

  <svg
    v-if="type == 'arrow_up'"
    class="arrow_up"
    width="17"
    height="21"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 7.75732L8.5 2.75732L13.5 7.75732"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 3.5L8.5 13"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-if="type == 'arrow_down'"
    class="arrow_down"
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 10.5762L8.5 15.5762L3.5 10.5762"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 14.8335V5.3335"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-if="type == 'arrow_left'"
    class="arrow_left"
    fill="#000000"
    width="17px"
    height="21px"
    viewBox="-78.5 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>left</title>
    <path d="M257 64L291 98 128 262 291 426 257 460 61 262 257 64Z" />
  </svg>

  <svg
    v-if="type == 'arrow_right'"
    class="arrow_right"
    fill="#000000"
    width="17px"
    height="21px"
    viewBox="-77 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>right</title>
    <path d="M98 460L64 426 227 262 64 98 98 64 294 262 98 460Z" />
  </svg>

  <svg
    v-if="type == 'arrow_up_right'"
    class="arrow_up_right"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 6.75001L15.75 2.25001M15.75 2.25001H11.25M15.75 2.25001L9 9M7.5 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V10.5"
      :stroke="color || '#00A3E9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- Full star icon -->
  <svg
    v-if="type == 'star'"
    class="icon-star"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
      :fill="color || '#F59E0B'"
    />
  </svg>

  <!-- Half star icon (left half filled) -->
  <svg
    v-if="type == 'star_half'"
    class="icon-star-half"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath :id="clipId">
        <rect x="0" y="0" :width="fillWidth" height="24" />
      </clipPath>
    </defs>
    <!-- Base (empty) star -->
    <path
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
      fill="#E5E7ED"
    />
    <!-- Left half filled -->
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
        :fill="color || '#F59E0B'"
      />
    </g>
  </svg>

  <svg
    v-if="type == 'chart_monitor'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    :stroke="color || '#4e4e4e'"
    stroke-width="2.2"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
    <path d="M6 12l4-4 4 4 4-4"></path>
  </svg>

  <svg
    v-if="type == 'tower'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    :stroke="color || '#4e4e4e'"
    stroke-width="2"
  >
    <path d="M4 22L12 2L20 22"></path>
    <path d="M12 2V22"></path>
    <path d="M8 12H16"></path>
    <path d="M6 17H18"></path>
    <path d="M10 7H14"></path>
    <path d="M4 22H20"></path>
  </svg>

  <svg
    v-if="type == 'system_performance'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    :stroke="color || '#4e4e4e'"
    stroke-width="2"
  >
    <!-- Tower Outline -->
    <path d="M5 22L12 2L19 22"></path>
    <path d="M12 2V22"></path>
    <path d="M8 12H16"></path>
    <path d="M6 18H18"></path>
    <path d="M9 7H15"></path>
    <!-- Performance Gauge ring inside tower base -->
    <path d="M17 18a5 5 0 0 0-10 0" stroke-width="1.5"></path>
    <line x1="12" y1="18" x2="14" y2="15" stroke-width="1.5"></line>
  </svg>
</template>

<script>
export default {
  props: ["color", "type", "fillValue"],
  data() {
    return {
      uniqueId: Math.random().toString(36).substr(2, 9),
    };
  },
  computed: {
    clipId() {
      return `star-clip-${this.uniqueId}`;
    },
    fillWidth() {
      return (this.fillValue || 0.5) * 24;
    },
  },
};
</script>
